export default __webpack_public_path__ + "static/media/carbon_money.209d1e42.svg";